import { render } from "./MyProcess.vue?vue&type=template&id=0fb7687d"
import script from "./MyProcess.vue?vue&type=script&lang=js"
export * from "./MyProcess.vue?vue&type=script&lang=js"

import "./MyProcess.vue?vue&type=style&index=0&id=0fb7687d&lang=css"

import exportComponent from "/Users/brian/Documents/web-projects/clients/andy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__